export default "__VITE_ASSET__zdkLP8Cl__"